import {
    CustomHomepageGrid,
    HomePageCompanyLogo,
    HomePageRandomJoke,
    HomePageRecentlyVisited,
    HomePageStarredEntities,
    HomePageTopVisited
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { AnnouncementsCard } from '@procore-oss/backstage-plugin-announcements';
import React from 'react';
import LogoFull from '../Root/LogoFull';

export const HomePage = () => (
    <CustomHomepageGrid>
    // Insert the allowed widgets inside the grid
        <HomePageCompanyLogo
            logo={<LogoFull />}
        />
        <AnnouncementsCard max={3} />
        <HomePageRecentlyVisited />
        <HomePageTopVisited />
        <HomePageSearchBar />
        <HomePageRandomJoke />
        <HomePageStarredEntities />
    </CustomHomepageGrid>
);